import React from 'react'
import {
  Box,
  Paper,
  Skeleton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material'
import { ProtectedPage } from '~/src/components/templates'

export const LoadingNormal: React.VFC = (): JSX.Element => {
  return (
    <ProtectedPage>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '24px',
        }}
      >
        <Skeleton width={'350px'} height={'60px'} />
        <Skeleton width={'350px'} height={'60px'} />
      </Box>
      <Paper>
        <Skeleton width={'150px'} height={'40px'} sx={{ ml: '16px' }} />
        <TableContainer
          sx={{ maxHeight: 440, background: '#FFFFFF', minWidth: 400, overflow: 'auto' }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((column, index) => (
                  <TableCell
                    key={index}
                    align={'left'}
                    style={{ minWidth: '110px', background: '#ffffff' }}
                  >
                    <Skeleton width={'110px'} height={'30px'} />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {[1, 2, 3, 4, 5].map((item, index) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((column, i) => (
                    <TableCell key={i} align={'left'}>
                      <Skeleton width={'110px'} height={'20px'} />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </ProtectedPage>
  )
}
